import ReducerUtilities from '../../../shared/store/reducer-utilities';
import noteModel from '../../models/note';
import noteCommitTypes from './commit-types';

const INITIAL_NOTE_STATE = {
  addingNoteFor: null,
  isEditingNote: null,
  list: null,
  isLoading: [],
};

function noteReducers(state = INITIAL_NOTE_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case noteCommitTypes.PUSH_NOTE:
      return {
        ...state,
        list: !state.list
          ? [noteModel(action.note)]
          : [
            noteModel(action.note),
            ...state.list,
          ],
      };
    case noteCommitTypes.PUSH_NOTES:
      return {
        ...state,
        list: action.notes.map(note => noteModel(note)),
      };
    case noteCommitTypes.REMOVE_NOTE:
      return {
        ...state,
        list: [
          ...ReducerUtilities.removeModelFromList(
            action.noteGuid,
            state.list,
          ),
        ],
      };
    case noteCommitTypes.REPLACE_NOTE:
      return {
        ...state,
        list: [
          ...ReducerUtilities.replaceModelInList(
            noteModel(action.note),
            state.list,
          ),
        ],
      };
    case noteCommitTypes.RESET_NOTE_STATE:
      return { ...INITIAL_NOTE_STATE };
    case noteCommitTypes.SET_ADDING_NOTE_FOR:
      return {
        ...state,
        addingNoteFor: action.addingNoteFor,
      };
    case noteCommitTypes.SET_IS_EDITING_NOTE:
      return {
        ...state,
        isEditingNote: action.isEditingNote,
      };
    case noteCommitTypes.SET_NOTES_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    default:
      return state;
  }
}

export default noteReducers;
